import jQuery from "jquery";
(function (far, $) {
  far.input = {};

  //#region Public functions ====================================================

  far.input.initialize = function () {
    disableReadOnlySelectBoxes();
    setupSelectToggles();
  };

  //#endregion

  //#region Private functions ===================================================

  function disableReadOnlySelectBoxes() {
    $("select[readonly]").focus(function () {
      this.blur();
    });
  }

  function setupSelectToggles() {
    $("select.js-togglefields")
      .on("change", function () {
        toggleFields($(this));
      })
      .each(function () {
        toggleFields($(this));
      });

    $("select.js-togglefieldset")
      .on("change", function () {
        toggleFieldset($(this));
      })
      .each(function () {
        toggleFieldset($(this));
      });
  }

  function toggleFields(selector) {
    var value = selector.val();
    var toggleValue = selector.data("togglefields-value");

    if (value == toggleValue) {
      selector
        .parent()
        .siblings(".form-group")
        .removeClass("form-group--hidden");
    } else {
      selector.parent().siblings(".form-group").addClass("form-group--hidden");
    }
  }

  function toggleFieldset(selector) {
    var value = selector.val();
    var toggleValue = selector.data("togglefieldset-value");

    if (value == toggleValue) {
      selector
        .parent()
        .siblings(".form--wrapper")
        .removeClass("form-group--hidden");
      selector
        .parent()
        .siblings(".form-group--title")
        .removeClass("form-group--hidden");
    } else {
      selector
        .parent()
        .siblings(".form--wrapper")
        .addClass("form-group--hidden");
      selector
        .parent()
        .siblings(".form-group--title")
        .addClass("form-group--hidden");
    }
  }

  //#endregion
})(window.far || (window.far = {}), jQuery);
